/**
 * Sichtbare Bezeichnungen für gespeicherte Codes. Die Werte in der
 * Datenbank bleiben unverändert.
 */

const STATUS = {
  active: 'Aktiv',
  inactive: 'Inaktiv',
  ended: 'Beendet',
  paused: 'Pausiert',
  cancelled: 'Gekündigt',
  canceled: 'Gekündigt',
  pending: 'Offen',
  waitlist: 'Warteliste',
  full: 'Ausgebucht',
  draft: 'Entwurf',
  open: 'Offen',
  closed: 'Geschlossen',
  completed: 'Abgeschlossen',
  sent: 'Versendet',
  delivered: 'Zugestellt',
  failed: 'Fehlgeschlagen',
  submitted: 'Eingereicht',
  reported: 'Gemeldet',
  accepted: 'Bestätigt',
  rejected: 'Abgelehnt',
  new: 'Neu',
  contacted: 'Kontaktiert',
  scheduled: 'Geplant',
  declined: 'Abgelehnt',
  approved: 'Genehmigt',
  confirmed: 'Bestätigt',
  available: 'Verfügbar',
  rented: 'Vermietet',
  maintenance: 'In Reparatur',
  decommissioned: 'Ausgemustert',
  returned: 'Zurückgegeben',
  terminated: 'Gekündigt',
  skipped_throttle: 'Ausgesetzt',
  blocked_denylist: 'Gesperrt',
};

const COURSE_TYPE = {
  individual: 'Einzelunterricht',
  group: 'Gruppenunterricht',
  workshop: 'Workshop',
  ensemble: 'Ensemble',
};

const RHYTHM = {
  weekly: 'Wöchentlich',
  biweekly: '14-tägig',
  monthly: 'Monatlich',
  individual: 'Individuell',
};

const EVENT = {
  create: 'Angelegt',
  update: 'Geändert',
  field_change: 'Änderung',
  status_change: 'Statusänderung',
  cancellation_added: 'Absage',
  payer_split_set: 'Zahleraufteilung',
  attendance_finalized: 'Anwesenheit abgeschlossen',
  attendance_unlocked: 'Anwesenheit geöffnet',
  attendance_corrected: 'Anwesenheit korrigiert',
  attendance_captured: 'Anwesenheit erfasst',
};

function fromMap(map, value) {
  if (value == null || value === '') return '';
  const key = String(value).trim().toLowerCase();
  return map[key] || String(value);
}

export function statusLabel(value) {
  return fromMap(STATUS, value);
}

export function courseTypeLabel(value) {
  return fromMap(COURSE_TYPE, value);
}

/** Einzelunterricht mit zwei Schülern zur gleichen Zeit ist 2er Gruppenunterricht. */
export function courseTypeForHeadcount(type, headcount) {
  const n = Number(headcount) || 0;
  const key = String(type || '').trim().toLowerCase();
  if ((key === 'individual' || key === 'einzel') && n === 2) return '2er Gruppenunterricht';
  if ((key === 'individual' || key === 'einzel') && n > 2) return 'Gruppenunterricht';
  return courseTypeLabel(type);
}

export function rhythmLabel(value) {
  return fromMap(RHYTHM, value);
}

export function eventLabel(value) {
  return fromMap(EVENT, value);
}
